/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perks_NavInputs */



/**
* | output |
* | --- |
* | "Perks" |
*
* @param {Perks_NavInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_nav = /** @type {((inputs?: Perks_NavInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_NavInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Привилегии")
	return /** @type {LocalizedString} */ ("Perks")
});